<template>
    <div id="report-page">
        <loader v-if="is('loading')"></loader>
        <div class="container-fluid" :class="{ hidden: !is('ready') }">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div>
                        <h1 class="pull-left">{{ t('forms-report-title') }}</h1>
                        <!-- To-do -->
                        <!-- <router-link :to="$route.query.forms_id ? `/forms/${$route.query.forms_id}` : '/forms'"  class="btn btn-primary pull-right">{{ $route.query.forms_id ? 'Ver Formulário' : 'Formulários' }} </router-link> -->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <!-- to-do :has-form-filter="true" -->
                    <filter-bar
                        :has-branch-filter="canFilterPerBranch"
                        :has-form-filter="hasFormFilter"
                        ref="filterBar"
                        @changed="loadData"
                        :filters="extraFilters"
                    />
                </div>
            </div>
           <div v-if="filters.forms" class="d-flex my-1 col-12 justify-content-end">
            <a
                class="btn btn-primary text-white"
                role="button"
                @click.prevent="
                    exportAnswers(filters.forms)
                "
                :title="t('forms-report-btn_export')"
            > <span class="export fa fa-download icon"></span> {{ t('forms-report-btn_export') }}</a>
           </div>

            <div v-for="(form, id) in forms" :key="form.id">
                <template v-if="objectToArray(form.answers).length > 0">
                    <div :key="id" class="row">
                        <hr v-if="id % 2 == 0" />
                        <div class="col-md-12 col-sm-12">
                            <h2 class="form-name">{{ form.name }}</h2>
                        </div>

                        <div class="col-md-12 col-sm-12">
                            <report-grade
                                class="grade-primary"
                                :useGrade="true"
                                :answers="
                                    form.questions.map((q) => q.answers)[id]
                                "
                                key="global"
                                :gradeClassMethod="gradeClass"
                            />

                            <div
                                v-if="
                                    getQuestionsByType('selectbox', id)
                                        .length ||
                                    getQuestionsByType('emotion', id).length
                                "
                                class="row"
                            >
                                <div
                                    class="col-md-6 question-grade-holder"
                                    v-for="question in getQuestionsByType(
                                        'emotion',
                                        id,
                                    )"
                                    :key="question.id"
                                >
                                    <report-grade
                                        :answers="
                                            objectToArray(question.answers)
                                        "
                                        :key="question.id"
                                        :gradeClassMethod="gradeClass"
                                    >
                                        <template slot="title">{{
                                            question.question
                                        }}</template>
                                    </report-grade>
                                </div>
                                <template
                                    v-for="question in getQuestionsByType(
                                        'selectbox',
                                        id,
                                    )"
                                >
                                    <div
                                        class="col-md-6 question-grade-holder"
                                        :key="question.id"
                                    >
                                        <report-selectbox
                                            :key="question.id"
                                            :answers="question.answers"
                                            :gradeClassMethod="gradeClass"
                                        >
                                            <template slot="title">{{
                                                question.question
                                            }}</template>
                                        </report-selectbox>
                                    </div>
                                </template>
                            </div>

                            <template
                                v-if="getQuestionsByType('boolean', id).length"
                            >
                                <report-boolean
                                    :answers="objectToArray(question.answers)"
                                    v-for="question in getQuestionsByType(
                                        'boolean',
                                        id,
                                    )"
                                    :key="question.id"
                                >
                                    <template slot="title">{{
                                        question.question
                                    }}</template>
                                </report-boolean>
                            </template>

                            <div
                                v-if="getQuestionsByType('comment', id).length"
                                class="row justify-content-center"
                            >
                                <template
                                    v-for="question in getQuestionsByType(
                                        'comment',
                                        id,
                                    )"
                                >
                                    <div
                                        class="col-12"
                                        :key="'c' + question.id"
                                    >
                                        <report-comment
                                            :answers="
                                                objectToArray(question.answers)
                                            "
                                            :gradeClassMethod="gradeClass"
                                        >
                                            <template slot="title">{{
                                                question.question
                                            }}</template>
                                        </report-comment>
                                    </div>
                                </template>
                            </div>

                            <div
                                v-if="getQuestionsByType('input', id).length"
                                class="row justify-content-center"
                            >
                                <template
                                    v-for="question in getQuestionsByType(
                                        'input',
                                        id,
                                    )"
                                >
                                    <div
                                        class="col-12"
                                        :key="question.id"
                                    >
                                        <report-input
                                            :answers="objectToArray(question.answers)"
                                            :gradeClassMethod="gradeClass"
                                        >
                                            <template slot="title">{{
                                                question.question
                                            }}</template>
                                        </report-input>
                                    </div>
                                </template>
                            </div>

                            <div
                                class="col-md-6 question-grade-holder"
                                v-for="question in getQuestionsByType(
                                    'nps',
                                    id,
                                )"
                                :key="question.id"
                            >
                                <report-nps
                                    :answers="
                                        objectToArray(question.answers)
                                    "
                                    :key="question.id"
                                    :gradeClassMethod="gradeClass"
                                >
                                    <template slot="title">{{
                                        question.question
                                    }}</template>
                                </report-nps>
                            </div>

                            <div
                                class="col-md-6 question-grade-holder"
                                v-for="question in getQuestionsByType(
                                    'ces',
                                    id,
                                )"
                                :key="question.id"
                            >
                                <report-ces
                                    :answers="
                                        objectToArray(question.answers)
                                    "
                                    :key="question.id"
                                    :gradeClassMethod="gradeClass"
                                >
                                    <template slot="title">{{
                                        question.question
                                    }}</template>
                                </report-ces>
                            </div>

                            <div
                                v-if="getQuestionsByType('date', id).length"
                                class="row justify-content-center"
                            >
                                <template
                                    v-for="question in getQuestionsByType(
                                        'date',
                                        id,
                                    )"
                                >
                                    <div
                                        class="col-12"
                                        :key="question.id"
                                    >
                                        <report-date
                                            :answers="objectToArray(question.answers)"
                                            :gradeClassMethod="gradeClass"
                                        >
                                            <template slot="title">{{
                                                question.question
                                            }}</template>
                                        </report-date>
                                    </div>
                                </template>
                            </div>

                            <div
                                v-if="getQuestionsByType('file', id).length"
                                class="row justify-content-center"
                            >
                                <template
                                    v-for="question in getQuestionsByType(
                                        'file',
                                        id,
                                    )"
                                >
                                    <div
                                        class="col-12"
                                        :key="question.id"
                                    >
                                        <report-file
                                            :answers="objectToArray(question.answers)"
                                            :gradeClassMethod="gradeClass"
                                        >
                                            <template slot="title">{{
                                                question.question
                                            }}</template>
                                        </report-file>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="objectToArray(form.answers).length === 0">
                    <div :key="id" class="row">
                        <div class="col-md-8 col-sm-12 no-answers-at-all">
                            <h2>
                                {{ t('forms-report-no_answers_found') }}
                                <span>{{ form.name }}</span>
                            </h2>
                            <span
                                >{{ t('forms-report-no_answers_description') }}</span
                            >
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";
import reportGrade from "./grade/grade.vue";
import reportBoolean from "./boolean/boolean.vue";
import reportComment from "./comment/comment.vue";
import reportSelectbox from "./selectbox/selectbox";
import reportInput from "./input/input.vue";
import reportNps from "./nps/nps.vue";
import reportCes from "./ces/ces.vue";
import reportDate from "./date/date.vue";
import reportFile from "./file/file.vue";
import FilterBar from "../components/reports/filter-bar";
import MathHelper from "../helpers/Math";
import Vue from "vue";
import saveData from "../helpers/saveData";
import { filter } from "minimatch";


export default {
    components: {
        "report-grade": reportGrade,
        "report-boolean": reportBoolean,
        "report-comment": reportComment,
        "report-selectbox": reportSelectbox,
        "report-input": reportInput,
        "report-nps": reportNps,
        "report-ces": reportCes,
        "report-date": reportDate,
        "report-file": reportFile,
        FilterBar,
    },
    props: {
        user: Object,
    },
    data: function () {
        return {
            extraFilters: [],
            state: "loading",
            answers: {},
            questions: [],
            forms: [],
            filters: {},
            gradeClass: function (average) {
                if (average) {
                    let classes = [
                        "horrible",
                        "bad",
                        "neutral",
                        "good",
                        "excellent",
                    ];
                    return "grade-" + classes[MathHelper.round(average) - 1];
                }
                return "grade-horrible";
            },
        };
    },
    created: function () {
        document.getElementsByTagName("title")[0].innerText =
            this.t('forms-report-page_title');
    },
    computed: {
        canFilterPerBranch() {
            return !!this.user.permissions["reports"]["options"][
                "global_access"
            ];
        },
        hasFormFilter() {
            return true;
        },
    },
    mounted() {
        const filterBar = this.$refs.filterBar;
        filterBar.addFilter("period");
        if (this.$module("segments")) {
            let options = keviApi.getOptions("segments");
            this.$http(options).then((response) => {
                let segments = response.body;
                this.extraFilters.push({
                    component: "checkbox",
                    label: this.$root.t('filter_bar-client_segments'),
                    name: "client-segments",
                    options: {
                        options: segments.map((seg) => ({
                            value: seg.id,
                            label: seg.name,
                        })),
                        icon: "fa-tag",
                    },
                    removable: true,
                });
            });
        }
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        getQuestionsByType: function (type, id = 0) {
            let questions = [];
            for (let q in this.forms[id].questions) {
                let question = this.forms[id].questions[q];
                if (
                    question.type === type &&
                    (question.active === "1" || question.answers.length > 0)
                ) {
                    questions.push(question);
                }
            }
            return questions;
        },
        loadData: function (filters) {
            this.filters = filters;
            this.setState("loading");
            var options = keviApi.getOptions("place/reports", "GET", {
                filters: filters,
            });
            this.$http(options).then(function (response) {
                if (response.status === 200) {
                    this.setState("ready");
                    this.forms = response.body;
                }
            });
        },
        objectToArray: function (object) {
            let newArray = [];
            for (let o in object) {
                newArray.push(object[o]);
            }
            return newArray;
        },
        exportAnswers(formId) {
            let data = {
                filters: this.filters
            };
            let requestOptions = keviApi.getOptions(
                "inbox/export",
                "GET",
                data,
            );
            Vue.http(requestOptions).then((response) => {
                if (response.status === 200) {
                    if (response.body) {
                        window.mixpanel?.track("Export form questions");
                        saveData(response.body, "respostas.csv");
                    }
                }
            });
        },
    },
};
</script>
